export const energyActions = [
  "Do 10 jumping jacks 🔥",
  "Start the task you’re avoiding — just 2 minutes",
  "Send that message now 📱",
  "Stand up, stretch, and smile 😄",
  "Hit play and move your body 🎵"
];
